export const vendorsMutations = {
  setVendorsFormStatus(state, payload) {
    state.vendorsFormStatus = payload;
  },
   setVendorsGroupFormStatus(state, payload) {
    state.vendorsGroupFormStatus = payload;
  },
  setVendorsIsEdit(state, payload) {
    state.vendorsIsEdit = payload
  },
   setVendorsGroupIsEdit(state, payload) {
    state.vendorsGroupIsEdit = payload
  },
  setVendorsSelectedForEdit(state, payload) {
    state.vendorsSelectedForEdit = payload
  },
  setVendorsGroupSelectedForEdit(state, payload) {
    state.vendorsGroupSelectedForEdit = payload
  },
  setVendorPermissionId(state, payload) {
    state.vendorPermissionId = payload
  },
  setVendorManageable(state, payload) {
    state.vendorManageable = payload
  },
  
  
};